import type { TableExtras } from '@/admin/ui/createTablePage';
import type { FilterField } from '~/styles/tables/filterandSettingsStyles';

export const WAITING_PAGE_SIZE = 20;

export function listQuery(
  search: string,
  extras: TableExtras,
): {
  limit: number;
  offset: number;
  search?: string;
  sort?: string;
  order?: 'asc' | 'desc';
} {
  return {
    limit: extras.paging.limit,
    offset: extras.paging.offset,
    ...(search ? { search } : {}),
    ...(extras.sort ? { sort: extras.sort.key, order: extras.sort.order } : {}),
  };
}

export function filterString(
  extras: TableExtras,
  key: string,
): string | undefined {
  const v = extras.filters[key];
  return typeof v === 'string' && v !== '' ? v : undefined;
}

export function filterStrings<T extends string = string>(
  extras: TableExtras,
  key: string,
): T[] | undefined {
  const v = extras.filters[key];
  return Array.isArray(v) && v.length > 0 ? (v as T[]) : undefined;
}

/** A positive integer typed into a text filter; anything else is no filter. */
export function filterInt(
  extras: TableExtras,
  key: string,
): number | undefined {
  const v = filterString(extras, key);
  const n = v === undefined ? Number.NaN : Number(v);
  return Number.isInteger(n) && n > 0 ? n : undefined;
}

export function filterInts(
  extras: TableExtras,
  key: string,
): number[] | undefined {
  return filterStrings(extras, key)
    ?.map(Number)
    .filter((n) => Number.isInteger(n) && n > 0);
}

export function field(
  key: string,
  label: string,
  type: FilterField['type'],
  options?: FilterField['options'],
): FilterField {
  return { key, label, type, ...(options ? { options } : {}) };
}
